import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SettingsTile } from './settings-tile';

export const SupportSettings = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SettingsTile
      icon={<SupportAgentOutlinedIcon />}
      title={t('settings.support')}
      detail={t('settings.supportHint')}
      onClick={() => navigate('/support')}
      trailing={<ChevronRightIcon sx={{ color: 'text.secondary' }} />}
    />
  );
};
